import { useState } from "react";
import { X, LogIn, Loader2, CheckCircle2 } from "lucide-react";
import { loginSendCode, loginVerify } from "@/lib/api";

export default function LoginModal({ onClose }) {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("phone");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const send = async () => {
    setBusy(true);
    setMsg("");
    try {
      await loginSendCode(phone);
      setStep("code");
      setMsg("Code WhatsApp pe bheja gaya ✓");
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Code send nahi hua, dubara try karo");
    }
    setBusy(false);
  };

  const verify = async () => {
    setBusy(true);
    setMsg("");
    try {
      const { data } = await loginVerify(phone, code.trim());
      localStorage.setItem("sahayak_session", data.session_id);
      setStep("done");
      setTimeout(() => window.location.reload(), 1200);
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Verify nahi hua, dubara try karo");
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-modal" className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl p-7 max-w-sm w-full relative">
        <button data-testid="login-close-btn" onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
          <X size={16} />
        </button>
        <div className="w-11 h-11 rounded-2xl bg-[#006D5B] text-white flex items-center justify-center mb-3">
          <LogIn size={19} />
        </div>
        <h3 className="font-heading font-bold text-xl mb-1">Mobile number se login</h3>
        <p className="text-sm text-gray-500 mb-5">
          Apna WhatsApp number daalo — OTP se login karo aur apne saare bills, khata aur subscription wapas pao.
        </p>
        {step === "done" ? (
          <div data-testid="login-success" className="flex items-center gap-2 bg-[#006D5B]/8 border border-[#006D5B]/20 rounded-xl p-4">
            <CheckCircle2 size={18} className="text-[#006D5B]" />
            <p className="text-sm font-bold text-[#006D5B]">Login ho gaya! Account load ho raha hai...</p>
          </div>
        ) : step === "phone" ? (
          <div className="space-y-3">
            <input
              data-testid="login-phone-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="10-digit WhatsApp number"
              className="w-full border border-gray-200 rounded-full px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#006D5B]/40"
            />
            <button data-testid="login-send-code-btn" onClick={send} disabled={busy || phone.trim().length < 10}
              className="w-full bg-[#006D5B] text-white text-sm font-bold py-3 rounded-full disabled:opacity-50 flex items-center justify-center gap-2">
              {busy ? <Loader2 size={15} className="animate-spin" /> : "OTP bhejo (WhatsApp pe)"}
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            <input
              data-testid="login-code-input"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="6-digit code"
              maxLength={6}
              className="w-full border border-gray-200 rounded-full px-4 py-3 text-sm font-mono tracking-widest outline-none focus:ring-2 focus:ring-[#006D5B]/40"
            />
            <button data-testid="login-verify-btn" onClick={verify} disabled={busy || code.trim().length !== 6}
              className="w-full bg-[#006D5B] text-white text-sm font-bold py-3 rounded-full disabled:opacity-50 flex items-center justify-center gap-2">
              {busy ? <Loader2 size={15} className="animate-spin" /> : "Login karo"}
            </button>
            <button data-testid="login-resend-btn" onClick={send} disabled={busy}
              className="text-[11px] text-gray-400 font-semibold underline">Code dubara bhejo</button>
          </div>
        )}
        {msg && step !== "done" && <p data-testid="login-status-msg" className="text-[11px] text-gray-500 mt-3">{msg}</p>}
      </div>
    </div>
  );
}
